module.exports = __webpack_public_path__ + "static/media/tie.28bbaa7d.svg";